export const formatString = (value: string) => {
  return `"${value.replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm, ' ').replace(/"/g, '""')}"`;
};


/**
 * Read through each of the lines and remove multiple line breaks in a row or if there
 * are trailing line breaks at the end of the array of lines.
 * @param lines: string[]
 * @returns string[]
 */
export const cleanMultiLines = (lines: string[]): string[] => {
  let lastLineBreak = false;
  return lines.filter((line, i) => {
    if (line.trim() === '') {
      if (lastLineBreak === true || i === lines.length - 1) {
        return false;
      } else {
        lastLineBreak = true;
      }
    } else {
      lastLineBreak = false;
    }
    return true;
  });
};

/**
 * Removes more than 2 consecutive line breaks and any beginning or trailing (line breaks, spaces, tabs, etc.)
 * @param {*} message 
 * @returns 
 */
export const cleanMessage = (message: string) => {
  return message.replace(/[\n]{2,}/g, "\n\n").trim();
};
